import { render, staticRenderFns } from "./userBlacklist.vue?vue&type=template&id=a77f3c64&scoped=true"
import script from "./userBlacklist.vue?vue&type=script&lang=js"
export * from "./userBlacklist.vue?vue&type=script&lang=js"
import style0 from "./userBlacklist.vue?vue&type=style&index=0&id=a77f3c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77f3c64",
  null
  
)

export default component.exports